exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-show-all[data-v-b597357c]{margin-top:1em;background-color:#f5f5f5;color:#8795a1;padding:.5em 0;text-align:center;font-size:.875em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b597357c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Basket/BasketSummary.vue
// module id = vAuk
// module chunks = 0